import * as Yup from 'yup';
import { minValidationString, requiredField } from '../../../lib/helperFuncs';
import { matchIsValidTel } from 'mui-tel-input';
import { maxValidationString } from '../../../lib/helperFuncs';

export const LocationRequestValidation = (name: string, surname:string) => {
  return Yup.object({
    // step 1
    title:
      Yup.string().required(requiredField)
        .min(1, minValidationString(1)).max(40, maxValidationString(40)),
    afm: Yup.string()
      .required(requiredField)
      .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
      .min(9, minValidationString(9))
      .max(9, maxValidationString(9)),
    email: Yup.string().required(requiredField).email('Μη αποδεκτή μορφή Email')
      .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/, 'Μη αποδεκτή μορφή Email'),
    phone_number: Yup.string()
      .required(requiredField)
      .test('phone_number', 'Παρακαλώ προσθέστε έγκυρη μορφή τηλεφώνου', (value) => matchIsValidTel(value || '')),
    // step 2
    dateFrom: Yup.string()
      .nullable()
      .required(requiredField),
    dateTo: Yup.string()
      .nullable()
      .required(requiredField)
      .test(
        'dateTo', 'Παρακαλώ προσθέστε έγκυρη μορφή ημερομηνίας',
        function (value) {
          const { dateFrom } = this.parent;
          return !dateFrom || new Date(value as string) >= new Date(dateFrom);
        }
      ),
    hours:
      Yup.array()
        .required(requiredField)
        .min(1, requiredField),
    info: Yup.string().required(requiredField)
      .min(1, minValidationString(1)).max(400, maxValidationString(400)),
    //step 3
    ...(name &&
      { 
        name: Yup.string()
          .required(requiredField)
          .min(3, minValidationString(3))
          .max(40, maxValidationString(40)) 
      }),
    ...(surname && 
        {
          surname: Yup.string()
            .required(requiredField)
            .min(3, minValidationString(3))
            .max(40, maxValidationString(40))
        }),
    tel: Yup.string()
      .required(requiredField)
      .test('tel', 'Παρακαλώ προσθέστε έγκυρη μορφή τηλεφώνου', (value) => matchIsValidTel(value || '')),
    email_manage: Yup.string().required(requiredField).email('Μη αποδεκτή μορφή Email')
      .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/, 'Μη αποδεκτή μορφή Email'),
    // step 4
    termsAndConditions: Yup.boolean()
      .required(requiredField)
      .test('checkboxTest', 'Αποδοχή Όρων Χρήσης & Ορθότητας Στοιχείων', (value) => value === true),
  });
};